import { render, staticRenderFns } from "./alasanRejectGadai.vue?vue&type=template&id=1c82d0bb&"
import script from "./alasanRejectGadai.vue?vue&type=script&lang=js&"
export * from "./alasanRejectGadai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports